/**
 * Get the pageViewId associated with the current page
 *
 * @returns {string} current page view identifier
 */
const getPageViewId = () => {
  return typeof window !== 'undefined' &&
    window.FUNDERA &&
    window.FUNDERA.pageViewId
    ? window.FUNDERA.pageViewId
    : null;
};

export { getPageViewId };
export default getPageViewId;
